


document.addEventListener("DOMContentLoaded", function (params) {
	changeTrackOrderURL();
	$('.all-orders-container').slick({
		dots: false,
		infinite: false,
		slidesToShow: 2,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: '<svg class="slick-btn-style slick-btn-1" width="45" height="45" viewBox="0 0 3.6 3.6" xmlns="http://www.w3.org/2000/svg" transform="rotate(-90)"><path d="M2.766 1.561 1.8.6l-.966.961a.1.1 0 1 0 .141.139L1.7.981v1.913a.1.1 0 1 0 .2 0V.981l.725.719a.1.1 0 0 0 .141-.142Z" class="clr-i-outline clr-i-outline-path-1"></path><path fill="none" d="M0 0h3.6v3.6H0z"></path></svg>',
		nextArrow: '<svg class="slick-btn-style slick-btn-2" width="45" height="45" viewBox="0 0 3.6 3.6" xmlns="http://www.w3.org/2000/svg" transform="rotate(90)"><path d="M2.766 1.561 1.8.6l-.966.961a.1.1 0 1 0 .141.139L1.7.981v1.913a.1.1 0 1 0 .2 0V.981l.725.719a.1.1 0 0 0 .141-.142Z" class="clr-i-outline clr-i-outline-path-1"></path><path fill="none" d="M0 0h3.6v3.6H0z"></path></svg>',
		responsive: [
			{
				breakpoint: 1430,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 678,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	// $('.ongoing-orders-container').slick({
	// 	dots: false,
	// 	infinite: false,
	// 	slidesToShow: 2,
	// 	slidesToScroll: 1,
	// 	arrows: true,
	// 	prevArrow: '<svg class="slick-btn-style slick-btn-1" width="45" height="45" viewBox="0 0 3.6 3.6" xmlns="http://www.w3.org/2000/svg" transform="rotate(-90)"><path d="M2.766 1.561 1.8.6l-.966.961a.1.1 0 1 0 .141.139L1.7.981v1.913a.1.1 0 1 0 .2 0V.981l.725.719a.1.1 0 0 0 .141-.142Z" class="clr-i-outline clr-i-outline-path-1"></path><path fill="none" d="M0 0h3.6v3.6H0z"></path></svg>',
	// 	nextArrow: '<svg class="slick-btn-style slick-btn-2" width="45" height="45" viewBox="0 0 3.6 3.6" xmlns="http://www.w3.org/2000/svg" transform="rotate(90)"><path d="M2.766 1.561 1.8.6l-.966.961a.1.1 0 1 0 .141.139L1.7.981v1.913a.1.1 0 1 0 .2 0V.981l.725.719a.1.1 0 0 0 .141-.142Z" class="clr-i-outline clr-i-outline-path-1"></path><path fill="none" d="M0 0h3.6v3.6H0z"></path></svg>',
	// 	responsive: [
	// 		{
	// 			breakpoint: 1430,
	// 			settings: {
	// 				slidesToShow: 2,
	// 				slidesToScroll: 1
	// 			}
	// 		},
	// 		{
	// 			breakpoint: 1024,
	// 			settings: {
	// 				slidesToShow: 1,
	// 				slidesToScroll: 1
	// 			}
	// 		},
	// 		{
	// 			breakpoint: 678,
	// 			settings: {
	// 				slidesToShow: 1,
	// 				slidesToScroll: 1
	// 			}
	// 		}
	// 	]
	// });
	// $('.completed-orders-container').slick({
	// 	dots: false,
	// 	infinite: false,
	// 	slidesToShow: 2,
	// 	slidesToScroll: 1,
	// 	arrows: true,
	// 	prevArrow: '<svg class="slick-btn-style slick-btn-1" width="45" height="45" viewBox="0 0 3.6 3.6" xmlns="http://www.w3.org/2000/svg" transform="rotate(-90)"><path d="M2.766 1.561 1.8.6l-.966.961a.1.1 0 1 0 .141.139L1.7.981v1.913a.1.1 0 1 0 .2 0V.981l.725.719a.1.1 0 0 0 .141-.142Z" class="clr-i-outline clr-i-outline-path-1"></path><path fill="none" d="M0 0h3.6v3.6H0z"></path></svg>',
	// 	nextArrow: '<svg class="slick-btn-style slick-btn-2" width="45" height="45" viewBox="0 0 3.6 3.6" xmlns="http://www.w3.org/2000/svg" transform="rotate(90)"><path d="M2.766 1.561 1.8.6l-.966.961a.1.1 0 1 0 .141.139L1.7.981v1.913a.1.1 0 1 0 .2 0V.981l.725.719a.1.1 0 0 0 .141-.142Z" class="clr-i-outline clr-i-outline-path-1"></path><path fill="none" d="M0 0h3.6v3.6H0z"></path></svg>',
	// 	responsive: [
	// 		{
	// 			breakpoint: 1430,
	// 			settings: {
	// 				slidesToShow: 2,
	// 				slidesToScroll: 1
	// 			}
	// 		},
	// 		{
	// 			breakpoint: 1024,
	// 			settings: {
	// 				slidesToShow: 1,
	// 				slidesToScroll: 1
	// 			}
	// 		},
	// 		{
	// 			breakpoint: 678,
	// 			settings: {
	// 				slidesToShow: 1,
	// 				slidesToScroll: 1
	// 			}
	// 		}
	// 	]
	// });
	$('.cancelled-orders-container').slick({
		dots: false,
		infinite: false,
		slidesToShow: 2,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: '<svg class="slick-btn-style slick-btn-1" width="45" height="45" viewBox="0 0 3.6 3.6" xmlns="http://www.w3.org/2000/svg" transform="rotate(-90)"><path d="M2.766 1.561 1.8.6l-.966.961a.1.1 0 1 0 .141.139L1.7.981v1.913a.1.1 0 1 0 .2 0V.981l.725.719a.1.1 0 0 0 .141-.142Z" class="clr-i-outline clr-i-outline-path-1"></path><path fill="none" d="M0 0h3.6v3.6H0z"></path></svg>',
		nextArrow: '<svg class="slick-btn-style slick-btn-2" width="45" height="45" viewBox="0 0 3.6 3.6" xmlns="http://www.w3.org/2000/svg" transform="rotate(90)"><path d="M2.766 1.561 1.8.6l-.966.961a.1.1 0 1 0 .141.139L1.7.981v1.913a.1.1 0 1 0 .2 0V.981l.725.719a.1.1 0 0 0 .141-.142Z" class="clr-i-outline clr-i-outline-path-1"></path><path fill="none" d="M0 0h3.6v3.6H0z"></path></svg>',
		responsive: [
			{
				breakpoint: 1430,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 678,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});


	const btn_for_reorder = document.querySelectorAll('.btn_for_reorder');

	btn_for_reorder.forEach(button => {
		button.addEventListener('click', function () {
			try {
				// Parse the order items (variant IDs and quantities) from the button's data attribute
				const orderItems = JSON.parse(this.getAttribute('data-order-items'));
				// Add all items (with their quantities) to the cart
				addItemsToCart(orderItems);
			} catch (error) {
				// console.error('Error parsing order items:', error);
			}
		});
	});

	// Function to add multiple items to the cart
	function addItemsToCart(items) {
		const data = { items };
		let itemsToAdd = []

		items.forEach((item) => {
			if (item.variantId && item.quantity) {
				itemsToAdd.push({
					id: item.variantId,
					quantity: item.quantity
				});
			}
		})

		if (itemsToAdd.length > 0) {
			// Make an AJAX request to add the items to the cart
			fetch('/cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ items: itemsToAdd })
			})
				.then(response => response.json())
				.then(cart => {

					const drawer = document.querySelector('.drawer');

					if (drawer.classList.contains('active')) {
					} else {
						drawer.classList.remove("is-empty")
						drawer.classList.add("active")
						const body_overflow = document.querySelector('body');
						body_overflow.classList.add('overflow-hidden');
					}

					$('.drawer').load(location.href + ' #CartDrawer');

					$('#cart-icon-bubble').load(location.href + ' #cart-icon-bubble');



					// Optionally, you can trigger a cart update or show a success message
					//   const cartDrawer = document.querySelector('cart-drawer');
					//       cartDrawer.classList.add('active');
				})
				.catch(error => {
					// console.error('Error adding items to cart:', error);
					alert('An error occurred while adding items to the cart.');
				});
		} else {
			alert('No items to reorder.');
		}


	}


})



function openOrderPopupBackground(orderId){
	const orderPopupBackground = document.querySelector('.order_items_blur_container-desktop')
	orderPopupBackground.dataset.orderId = orderId
	orderPopupBackground.style.display = 'flex'
	document.getElementById(`order-products-${ orderId }`).style.display = 'flex'
}

function hideOpenOrderPopupBackground(elm){
	
	elm.style.display = 'none'
	document.getElementById(`order-products-${ elm.getAttribute('data-order-id') }`).style.display = 'none'
}

function hideOpenOrderPopups(orderId){
	
	const orderPopupBackground = document.querySelector('.order_items_blur_container-desktop')
	orderPopupBackground.dataset.orderId = orderId
	orderPopupBackground.style.display = 'none'
	document.getElementById(`order-products-${ orderId }`).style.display = 'none'
}


function changeTrackOrderURL() {
	const allTrackedOrders = document.querySelectorAll('.put_url_to_track');
	allTrackedOrders.forEach((trackOrder) => {
	  const orderId = trackOrder.getAttribute('data-order-id');
	  fetchTrackingUrl(orderId)
		.then(url => {
		  console.log('url:', url);
		  if (url) {
			trackOrder.setAttribute('href', url);
		  } else {
			const parentDiv = trackOrder.closest('.for_tracking_orders');
			if (parentDiv) {
			  parentDiv.innerHTML = `<p>Available soon</p>`;
			}
			trackOrder.remove();
		  }
		})
		.catch(() => {
		  const parentDiv = trackOrder.closest('.for_tracking_orders');
		  if (parentDiv) {
			parentDiv.innerHTML = `<p>Available soon</p>`;
		  }
		  trackOrder.remove();
		});
	});
  }
  
  
  const fetchTrackingUrl = async (orderId) => {
	try {
	  const response = await fetch("https://api.scrollengine-delivery.com/api/v3/service/tracking/order", {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ "shop_url": "animeal-store.myshopify.com", "order_id": orderId })
	  });
	  const data = await response.json();
	  if (data.status === false && data.msg === "Order details not valid!") return null;
	  return data?.data?.[0]?.shipment?.trackingInfo?.url || null;
	} catch {
	  return null;
	}
  };
  
  document.addEventListener("DOMContentLoaded", function() {
	document.querySelectorAll('.order-received-btn').forEach((btn) => {
	  const order_id = btn.getAttribute('data-order-id');
  
	  btn.addEventListener('click', async function() {
		// Display confirmation dialog
		const userConfirmed = window.confirm("Are you sure you have received this order? This action will mark the order as completed.");
  
		if (userConfirmed) {
		  try {
			const response = await fetch('https://nodejs.animeal.in/api/my-order-delivered', {
			  method: 'POST',
			  headers: {
				'Content-Type': 'application/json',
			  },
			  body: JSON.stringify({ order_id })
			});
  
			const data = await response.json();
  
			const parent = btn.closest('.is-order-received');
  
			// Empty the parent element before updating it
			parent.innerHTML = '';
  
			// Create the status message
			const statusMessage = document.createElement('span');
			statusMessage.style.color = data.success ? 'green' : 'red';
			statusMessage.textContent = data.success 
			  ? 'Thanks for Confirmation.' 
			  : 'Error occurred. Please try after sometime.';
  
			parent.appendChild(statusMessage);
  
		  } catch (error) {
			const parent = btn.closest('.is-order-received');
  
			// Empty the parent element before updating it
			parent.innerHTML = '';
  
			const statusMessage = document.createElement('span');
			statusMessage.style.color = 'red';
			statusMessage.textContent = 'Error occurred. Please try after sometime.';
			
			parent.appendChild(statusMessage);
		  }
		} else {
		  // If the user cancels, no action is taken, and no changes are made
		  return;
		}
	  });
	});
  });
  
  
  
  





